export default __webpack_public_path__ + "static/media/logo.a50d6949.png";